// extracted by css-extract-rspack-plugin
export default {"container":"EmptyCliSession-module__container__vP2zp"};